export default __webpack_public_path__ + "static/media/character.57940660.png";